module.exports = __webpack_public_path__ + "media/images/flags/1x1/aus-efec3960ac032beb73588d4be3952890.svg";